import sessionMixin from "@/components/shared/mixins/sessionMixin";

export default {
  name: "NotFound",
  mixins: [sessionMixin],
  mounted() {
    this.$resetState();
  },
  methods: {
    clearStorage() {
      this.$router.push("/").then(() => {
        localStorage.clear();
        window.location.reload();
      });
    }
  }
};
